<script lang="ts" setup>
import { computed } from 'vue'
import WhoWeAreHero from '@/components/BrandedV2/WhoWeAreHero/index.vue'
import WhoWeAreInvestments from '@/components/BrandedV2/WhoWeAreInvestments/index.vue'
import WhoWeAreLaHausVerified from '@/components/BrandedV2/WhoWeAreLaHausVerified/index.vue'
import WhoWeAreLaHausHelpsYou from '@/components/BrandedV2/WhoWeAreLaHausHelpsYou/index.vue'
import WhoWeAreHappyClients from '@/components/BrandedV2/WhoWeAreHappyClients/index.vue'
import WhoWeAreLaHausMedia from '@/components/BrandedV2/WhoWeAreLaHausMedia/index.vue'
import WhoWeAreLaHausAboutUs from '@/components/BrandedV2/WhoWeAreLaHausAboutUs/index.vue'
import { SCREEN } from '@/utils/segment'

const dataAttributes = computed(() => {
  return {
    dataLh: {
      P: SCREEN.WHO_WE_ARE
    }
  }
})

</script>

<script lang="ts">
export default {
  name: 'PageWhoWeAre'
}
</script>

<template>
  <div>
    <WhoWeAreHero />

    <WhoWeAreInvestments />

    <WhoWeAreLaHausVerified />

    <WhoWeAreLaHausHelpsYou />

    <WhoWeAreHappyClients />

    <WhoWeAreLaHausMedia :data-attributes="{...dataAttributes, dataLh: { ...dataAttributes.dataLh, Z: 'lahaus en medios'}}" />

    <WhoWeAreLaHausAboutUs :data-attributes="{...dataAttributes, dataLh: { ...dataAttributes.dataLh, Z: 'lo que necesitas saber sobre lahaus'}}" />
  </div>
</template>
